import React from 'react'
import { Button, Result } from 'antd'
import { registrarErro } from 'utils/registrarErro'

// Error Boundaries só existem como class component no React — não há
// equivalente em hooks ainda. Sem isso em algum lugar da árvore, uma
// exceção de render em QUALQUER página (lazy-loaded ou não) derruba o app
// inteiro pra uma tela em branco, sem chance de recuperação sem recarregar
// manualmente a URL.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Erro não tratado capturado pelo ErrorBoundary:', error, errorInfo)
    registrarErro(error, errorInfo?.componentStack)
  }

  componentDidUpdate(prevProps) {
    // Se o usuário navegou para outra rota (resetKey mudou), sai do estado
    // de erro em vez de continuar mostrando o fallback pra sempre.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: null })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Algo deu errado nesta tela"
          subTitle="Isso já foi registrado. Você pode tentar voltar ao início ou recarregar a página."
          extra={[
            <Button type="primary" key="dashboard" onClick={() => { window.location.href = '/dashboard' }}>
              Voltar ao início
            </Button>,
            <Button key="reload" onClick={() => window.location.reload()}>
              Recarregar página
            </Button>,
          ]}
        />
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
